module.exports = __webpack_public_path__ + "img/Logo.e6ed175d.png";